import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/fin_entregas";

const getEntregas = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

const createEntrega = async (data, usuario = "system") => {
  const response = await axios.post(`${baseUrl}${endpoint}`, data, {
    headers: { usuario }
  });
  return response.data;
};

const updateEntrega = async (id, data, usuario = "system") => {
  const response = await axios.put(`${baseUrl}${endpoint}/${id}`, data, {
    headers: { usuario }
  });
  return response.data;
};

const deleteEntrega = async (id, usuario = "system") => {
  const response = await axios.delete(`${baseUrl}${endpoint}/${id}`, {
    headers: { usuario }
  });
  return response.data;
};

const getStockProducto = async (id) => {
  const response = await axios.get(
    `${baseUrl}/api/financiero/fin_entregas/stock/${id}`
  );
  return response.data;
};

export {
  getEntregas,
  createEntrega,
  updateEntrega,
  deleteEntrega,
  getStockProducto
};